import React from "react";
import { Link } from "react-router-dom";
import logoimg from "../../images/logo.png";

import { Navbar, Nav, Container } from 'react-bootstrap';

const AppHeader = () => {
 

  return (
    <>

   <Navbar bg="dark" data-bs-theme="dark" expand="lg" sticky="top">
      <Container fluid>
        <Navbar.Brand className="me-lg-auto" as={Link} to={"/"}>
          <img
            src={logoimg}
            alt="Logo"
            
            className="d-inline-block header-nav-logo align-top"
          />
        </Navbar.Brand>
      

         <ul className="nav col-auto justify-content-start my-md-0 text-small">
                       <Nav.Link className="app-nav-link mobile-hide mobile-font" as={Link} to={"/"}>Home</Nav.Link>


          <Nav.Link className="app-nav-link mobile-hide mobile-font" as={Link} to="/about">About</Nav.Link>

             <Nav.Link className="app-nav-link mobile-font mobile-hide" as={Link} to={"/services"}>Services</Nav.Link>
            <Nav.Link className="app-nav-link mobile-font" as={Link} to={"/projects"}>Projects</Nav.Link>
           <Nav.Link className="app-nav-link mobile-hide mobile-font" as={Link} to={"/contact"}>Contact</Nav.Link>
  
        </ul>

      </Container>
    </Navbar>

 
  <div className="blog-nav-wrapper desktop-hide bg-primary-dark align-items-center mb-3 d-flex flex-nowrap">
      <Container fluid>
    <ul className="nav blog-nav-pills align-middle">
          <Link className="blog-nav-item blog-nav-btn mobile-text app-nav-link" to={"/"}>Home </Link>
          <Link className="blog-nav-item blog-nav-btn mobile-text app-nav-link" to={"/about"}>About </Link>
          <Link className="blog-nav-item blog-nav-btn mobile-text app-nav-link" to={"/services"}>Services </Link>
          <Link className="blog-nav-item blog-nav-btn mobile-text app-nav-link" to={"/contact"}>Contact </Link>
    </ul>
      </Container>
 </div>

 <div className="mb-2"></div>

    </>
  );
};

export default AppHeader;
